import React from "react"
import { graphql, Link } from "gatsby"
import Img from "gatsby-image"

import Layout from "../components/layout"

import SEO from "../components/seo"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { /*faUtensils,*/ faCheckSquare } from "@fortawesome/free-solid-svg-icons"


export default ({ data, location }) => (
<Layout>
    <SEO
        pagetitle="Tyler(タイラー)について"
        pagedesc="私、Tyler(タイラー)に関してとTyler Blogに関しての紹介ページ"
        pagepath={location.pathname}
        pageimg={data.about.childImageSharp.original.src}
        pageimgw={data.about.childImageSharp.original.width}
        pageimgh={data.about.childImageSharp.original.height}

    />
    <div>
    <div className="eyecatch">
        <figure>
        <Img fluid={data.about.childImageSharp.fluid} alt="myphoto" />
        </figure>
    </div>
    <article className="content">
        <div className="container">
        <h1 className="bar">About Tyler blog</h1>
        <aside className="info">
          <p>

          </p>
        </aside>
        <div className="postbody">
            <p>このブログは私が学んだこと、これからのことを綴っていきます。このブログは静的ジェネレーターで構築されています。</p>
            <h2><FontAwesomeIcon icon={faCheckSquare} />This is me...</h2>
            <ul>
              <li>Name: Tyler(タイラー)</li>
              <li>Work: Saas事業関連、Webサイト制作、オンラインサロン 、地方創生、新規事業開発、コンサルティング、映像制作、音楽制作</li>
              <li>Hobby: カメラ、アニメ、音楽、ギター</li>
              <li>Life vison: 毎日楽しく悠々自適に過ごす</li>            
            </ul>
            <h2><FontAwesomeIcon icon={faCheckSquare} />History</h2>
            <p>新入社員で中小企業SE会社に4年勤め、その後シンガポールへ英語留学。そこで出会った仲間とタスク管理アプリJootoを立ち上げる。2017年にPR TIMESへ事業譲渡しそのまま社員になり事業部長へ就任。2020年10月から独立し長野へ移住し様々な活動を進める。</p>
            <p>気長にお付き合いいただければ幸いです。</p>
            <p>お問い合わせはこちら
              <div className="link-color">
                <Link to={`https://4sf023busxd.typeform.com/to/VEPcEgua`} target="_blank">Contact</Link>
              </div>
            </p>
        </div>
        </div>
    </article>
    </div>

</Layout>
)


export const query = graphql`
  query  {
    about: file(relativePath: {eq: "about.jpg"}) {
      childImageSharp {
        fluid(maxWidth: 1600) {
          ...GatsbyImageSharpFluid_withWebp_tracedSVG
        }
        original {
            src
            height
            width
        }
      }
    }



  }
`

//let head = "頭じゃここ"